import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CaseDataService } from "../../_dataservices/CaseDataService";
import { AppMaterialModule } from '../../../app/layouts/material/app.material.module';
import { PipesModule } from '../../_appCommon/pipes/pipes.module';
import { CustomerDataService } from "../../_dataservices/CustomerDataService";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppShareModule } from "src/shared/app.module";
import { ProductModule } from "../products/product.module";
import { ShareModule } from '../../_appCommon/share.module';
import { PrescriptionRoutingModule } from "./prescription.routing.module";
import { CrudPrescriptionComponent } from "./crud/crud-prescription.component";
import { FirstStepComponent } from "./crud/first-step/first-step.component";
import { SecondStepComponent } from "./crud/second-step/second-step.component";
import { ThirdStepComponent } from "./crud/third-step/third-step.component";
import { FourthStepComponent } from "./crud/fourth-step/fourth-step.component";
import { FifthStepComponent } from "./crud/fifth-step/fifth-step.component";
import { SixthStepComponent } from "./crud/sixth-step/sixth-step.component";
import { SeventhStepComponent } from "./crud/seventh-step/seventh-step.component";
import { EighthStepComponent } from "./crud/eighth-step/eighth-step.component";
import { NinethStepComponent } from "./crud/nineth-step/nineth-step.component";
import { PrescriptionDataService } from "src/app-client/_dataservices/PrescriptionDataService";
import { ImageSliderComponent } from './image-slider/image-slider/image-slider.component';
import { SliderImagesDataService } from "src/app-client/_dataservices/SliderImagesDataService";

@NgModule({
  declarations: [
    CrudPrescriptionComponent,
    FirstStepComponent,
    SecondStepComponent,
    ThirdStepComponent,
    FourthStepComponent,
    FifthStepComponent,
    SixthStepComponent,
    SeventhStepComponent,
    EighthStepComponent,
    NinethStepComponent,
    ImageSliderComponent,
  ],
  exports: [
    CrudPrescriptionComponent
  ],
  imports: [
    CommonModule,
    PrescriptionRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ShareModule,
    AppShareModule,
    ProductModule,
    AppMaterialModule,
    PipesModule
  ],
  providers: [
    CaseDataService, 
    CustomerDataService,
    PrescriptionDataService,
    SliderImagesDataService
  ]
})

export class PrescriptionModule { }
